<template>
  <div>
    <div class="container-xxl-fluid mb-4">
      <div class="row">
        <div class="col-lg-12">
          <v-expansion-panels v-model="panel" accordion focusable flat>
            <ReportTypes @reportTypeChange="data => reportTypeChange(data)"></ReportTypes>
            <v-expansion-panel key="1">
              <v-expansion-panel-header>
                Detaylı Filtreleme
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="container-xxl-fluid py-4">
                  <div class="row">
                    <div class="col-lg-12 text-center">
                      <v-btn @click="panel = 0" small color="primary">RAPOR SEÇİMİNE DÖN</v-btn>
                    </div>
                  </div>
                  <div class="row" v-if="reportType && !reportFilterComponent">
                    <div class="col-lg-12 text-center">
                      <h5>Bu rapor türüne ait filtre bulunmamaktadır</h5>
                    </div>
                  </div>
                  <component :is="reportFilterComponent" v-bind="dynamicProps" @reportFilterChange="data => filterReportTypeData(data)">
                  </component>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-lg-12 text-center">
            <h5>{{ reportType ? reportType.title : '' }}</h5>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div v-if="reportTypeTest !== 'Ziyaret Raporu'">
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10 </v-btn>
                <v-btn @click="perPage = 20"> 20 </v-btn>
                <v-btn @click="perPage = 30"> 30 </v-btn>
                <v-btn @click="perPage = 50"> 50 </v-btn>
              </v-btn-toggle>
            </div>
            <div class="ms-auto">
              Bulunan Kayıt Sayısı : <b>{{ reportMetaData.totalCount }}</b>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="text-end mb-3">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    plain
                    :loading="allDataForExcelLoading"
                    :disabled="allDataForExcel.length > 1"
                    v-bind="attrs"
                    v-on="on"
                    @click="getAllDataForExcel"
                >
                  <v-icon color="indigo" small class="me-2">mdi-information</v-icon>
                  <span>Verileri İndir</span>
                </v-btn>
              </template>
              <span>Tüm Verileri Excel Olarak Aktarmak İçin Önce İndiriniz</span>
            </v-tooltip>
            <ExcelExport :button-title="'Tüm Sayfalar'" :file-name-prop="setExcelFileName"  :data-prop="allDataForExcel" :column-prop="reportListHeaders" :button-enabled="!excelButton"></ExcelExport>
          <ExcelExport :button-title="'Sayfa'" :file-name-prop="setExcelFileName" :data-prop="reportMetaData.data" :column-prop="reportListHeaders"></ExcelExport>
          </div>
          <ReportTableView :perPage="perPage">
            <template v-slot:currentActionDetailButton="{model}">
              <div class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="primary darken-2"
                        @click="openMalDetayKarlilikDialog(model)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Mal Detaylı Kârlılık</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:amount="data">
              {{ numberConverter(data.model.amount) }}
            </template>
            <template v-slot:currencyAmount="data">
              {{ numberConverter(data.model.currencyAmount) }}
            </template>
            <template v-slot:quantity="data">
              {{numberConverter(data.model.quantity).slice(0, -3)}}
            </template>
            <template v-for="item in reportListSlots" v-slot:[item]="data">
              {{ numberConverter(data.model[item])}}
            </template>
          </ReportTableView>
        </div>
        <!-- end row -->
        <div class="row" v-if="reportTypeTest !== 'Ziyaret Raporu'">
          <div class="col-lg-12 mb-5">
            <v-pagination
              v-model="currentPage"
              class="my-4"
              :length="reportMetaData.length < 1 || !reportMetaData ? 1 : reportMetaData.totalPages"
              :total-visible="8"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
    <MalDetayKarlilikDialog :currentProp="malDetayKarlilikProp" :showDialog="malDetayKarlilikDialog" @dialogChange="e => this.malDetayKarlilikDialog = e"></MalDetayKarlilikDialog>
  </div>
</template>

<script>
import ReportTableView from "@/components/management/detailed-reports/views/ReportTableView.vue";
import ReportTypes from "./types/ReportTypes.vue";
import FaturaKarlilik from "@/components/management/detailed-reports/filters/FaturaKarlilik";
import StokAnaliz from "@/components/management/detailed-reports/filters/StokAnaliz";
import HedefPotansiyelCari from "@/components/management/detailed-reports/filters/HedefPotansiyelCari";
import HedefPotansiyelPlasiyer from "@/components/management/detailed-reports/filters/HedefPotansiyelPlasiyer";
import PlasiyerUrunSatis from "@/components/management/detailed-reports/filters/PlasiyerUrunSatis";
import EnIyiSatis from "@/components/management/detailed-reports/filters/EnIyiSatis";
import CariPerformans from "@/components/management/detailed-reports/filters/CariPerformans";
import GenelBorcAlacak from "@/components/management/detailed-reports/filters/GenelBorcAlacak";
import CekRaporu from "@/components/management/detailed-reports/filters/CekRaporu";
import SenetRaporu from "@/components/management/detailed-reports/filters/SenetRaporu";
import KasaRaporu from "@/components/management/detailed-reports/filters/KasaRaporu";

import MalDetayKarlilikDialog from "@/components/management/detailed-reports/dialogs/MalDetayKarlilikDialog";

import { mapState, mapActions, mapMutations } from "vuex";
import ZiyaretRaporu from "@/components/management/detailed-reports/filters/ZiyaretRaporu.vue";
import YeniCariRaporu from "@/components/management/detailed-reports/filters/YeniCariRaporu.vue";
import ExcelExport from "@/components/shared/ExcelExport.vue";
import {numberConverter} from "../../../../helpers";

export default {
  components: {
    ExcelExport,
    ReportTableView,
    ReportTypes,
    FaturaKarlilik,
    StokAnaliz,
    HedefPotansiyelCari,
    HedefPotansiyelPlasiyer,
    PlasiyerUrunSatis,
    EnIyiSatis,
    CariPerformans,
    GenelBorcAlacak,
    CekRaporu,
    SenetRaporu,
    KasaRaporu,
    MalDetayKarlilikDialog,
    ZiyaretRaporu,
    YeniCariRaporu
  },
  mounted() {
    this.setReportType(null);
  },
  computed: {
    ...mapState("payment", ["paymentMethodList"]),
    ...mapState("auth", ["user"]),
    ...mapState("report", ["reportTypeTest","reportListHeaders","reportListSlots"]),
    dynamicProps(){
      return {reportType : this.reportType};
    },
    excelButton: function () {
      return this.allDataForExcel.length > 0
    },
    setExcelFileName: function () {
      return `${this.reportTypeTest} ${this.filterRequestObject.StartDate} - ${this.filterRequestObject.FinishDate}`
    }
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      showNewUserDialog: false,
      paymentMethod: null,
      malDetayKarlilikDialog: false,
      malDetayKarlilikProp:{},
      panel:0,
      reportType: null,
      reportFilterComponent: null,
      filterRequestObject:{},
      reportMetaData:[],
      allDataForExcel: [],
      allDataForExcelLoading: false,
    };
  },
  methods: {
    numberConverter,
    ...mapActions("payment", ["fetchPaymentMethodList"]),
    ...mapActions("report", ["fetchReport"]),
    ...mapMutations("report", ["setReportListData","setReportListHeaders", "setReportType"]),
    searchClicked() {},
    openMalDetayKarlilikDialog(prop) {
      this.malDetayKarlilikDialog = true;
      this.malDetayKarlilikProp = prop;
    },
    reportTypeChange(reportType){
      this.reportType = reportType
      switch (this.reportType.title){
        case 'Fatura Karlılık Raporu':
          this.setReportType("Fatura Karlılık Raporu");
          this.reportFilterComponent = 'FaturaKarlilik'
          break;
        case 'Stok Analiz Raporu':
          this.setReportType("Stok Analiz Raporu");
          this.reportFilterComponent = 'StokAnaliz'
          break;
        case 'Hedef & Potansiyel Cari Raporu':
          this.setReportType("Hedef & Potansiyel Cari Raporu");
          this.reportFilterComponent = 'HedefPotansiyelCari';
          break;
        case 'Hedef & Potansiyel Plasiyer Raporu':
          this.setReportType("Hedef / Potansiyel Plasiyer Raporu");
          this.reportFilterComponent = 'HedefPotansiyelPlasiyer';
          break;
        case 'Plasiyer Ürün Satış Raporu':
          this.setReportType("Plasiyer Ürün Satış Raporu");
          this.reportFilterComponent = 'PlasiyerUrunSatis';
          break;
        case 'En İyi Satış Raporu':
          this.setReportType("En İyi Satış Raporu");
          this.reportFilterComponent = 'EnIyiSatis';
          break;
        case 'Cari Performans Raporu':
          this.setReportType("Cari Performans Raporu");
          this.reportFilterComponent = 'CariPerformans';
          break;
        case 'Genel Borç/Alacak':
          this.setReportType("Genel Borç/Alacak");
          this.reportFilterComponent = 'GenelBorcAlacak';
          break;
        case 'Çek Raporu':
          this.setReportType("Çek Raporu");
          this.reportFilterComponent = 'CekRaporu';
          break;
        case 'Senet Raporu':
          this.setReportType("Senet Raporu");
          this.reportFilterComponent = 'SenetRaporu';
          break;
        case 'Kasa Raporu':
          this.setReportType("Kasa Raporu");
          this.reportFilterComponent = 'KasaRaporu';
          break;
        case 'Ziyaret Raporu':
          this.setReportType("Ziyaret Raporu");
          this.reportFilterComponent = 'ZiyaretRaporu';
          break;
        case 'Yeni Cari Raporu':
          this.setReportType("Yeni Cari Raporu");
          this.reportFilterComponent = 'YeniCariRaporu';
          break;
        default:
          this.setReportType(null);
          this.reportFilterComponent = null;
      }
      this.setReportListData([]);
      this.setReportListHeaders([]);
      this.reportMetaData = [];
      this.panel= 1;
    },
    async filterReportTypeData(filterRequestObject){
      if (this.reportType.title === 'Ziyaret Raporu' || this.reportType.title === 'Yeni Cari Raporu') {
        this.filterRequestObject = filterRequestObject;
        let params = {};

        Object.entries(filterRequestObject).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            params[key] = value;
          }
        });
        let result = await this.fetchReport({
          reportType: this.reportType.title,
          params: params,
          body: {},
        });
        if(result && result.data && result.data.success)
        {
          this.reportMetaData = result.data;
        }
        else{
          this.reportMetaData = false;
        }
      } else {
      this.filterRequestObject = filterRequestObject;
      let result = await this.fetchReport({
        reportType: this.reportType.title,
        params:{
          pageNumber: this.currentPage,
          pageSize: this.perPage
        },
        body: this.filterRequestObject
      });
      if(result && result.data && result.data.success)
      {
        this.reportMetaData = result.data;
      }
      else{
        this.reportMetaData = false;
      }
    }
    },
    async getAllDataForExcel() {
      this.allDataForExcelLoading = true;
      let result = await this.fetchReport({
        reportType: this.reportType.title,
        params:{
          pageNumber: 1,
          pageSize: this.reportMetaData.totalCount
        },
        body: this.filterRequestObject
      });
      if(result && result.data && result.data.success)
      {
        this.allDataForExcel = result.data.data;
      }
      else{
        this.allDataForExcel = [];
      }
      this.allDataForExcelLoading = false;
    }
  },
  watch: {
    perPage: function (newVal) {
      this.currentPage = 1;
      newVal
      this.filterReportTypeData(this.filterRequestObject);

    },
    currentPage: function (newVal) {
      newVal;
      this.filterReportTypeData(this.filterRequestObject);
    },
  },
};
</script>
